// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabMenu_tabMenu__pf-83"};